import { HealthTimeline } from "@/features/patient/records/components/HealthTimeline";
import { useTimeline } from "@/features/patient/records/utils/adaptTimeline";

export function TimelinePage() {
  const { items, isLoading } = useTimeline();
  return <HealthTimeline items={items} isLoading={isLoading} />;
}
